/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { AzureVaultType } from '../models/AzureVaultType';

/**
* Azure restore point data for VM-level snapshots
*/
export class AzureRestorePointData {
  /**
  * Full Azure restore point resource ID (required for conversion)
  */
  'restorePointId': string;
  /**
  * Human-readable restore point name for UI display
  */
  'restorePointName': string;
  /**
  * Type of Azure restore point
  */
  'restorePointType': AzureRestorePointDataRestorePointTypeEnum;
  /**
  * Azure region/location (maps to \"region\" in conversion API)
  */
  'location': string;
  /**
  * Restore point creation time (maps to \"recoveryPointTime\" in conversion API)
  */
  'createdAt': Date;
  /**
  * Array of disk resource IDs. May be empty if recovery point lacks disk configuration metadata  (common for older backups or when VM Agent wasn\'t running). Conversion and restore still work  as Azure Backup Service has the disk data internally. 
  */
  'diskIds': Array<string>;
  /**
  * Vault name (required for recovery_services type restore points)
  */
  'vaultName'?: string;
  /**
  * Vault resource group (required for recovery_services type)
  */
  'vaultResourceGroup'?: string;
  'vaultType'?: AzureVaultType | null;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "restorePointId",
      "baseName": "restorePointId",
      "type": "string",
      "format": ""
    },
    {
      "name": "restorePointName",
      "baseName": "restorePointName",
      "type": "string",
      "format": ""
    },
    {
      "name": "restorePointType",
      "baseName": "restorePointType",
      "type": "AzureRestorePointDataRestorePointTypeEnum",
      "format": ""
    },
    {
      "name": "location",
      "baseName": "location",
      "type": "string",
      "format": ""
    },
    {
      "name": "createdAt",
      "baseName": "createdAt",
      "type": "Date",
      "format": "date-time"
    },
    {
      "name": "diskIds",
      "baseName": "diskIds",
      "type": "Array<string>",
      "format": ""
    },
    {
      "name": "vaultName",
      "baseName": "vaultName",
      "type": "string",
      "format": ""
    },
    {
      "name": "vaultResourceGroup",
      "baseName": "vaultResourceGroup",
      "type": "string",
      "format": ""
    },
    {
      "name": "vaultType",
      "baseName": "vaultType",
      "type": "AzureVaultType",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return AzureRestorePointData.attributeTypeMap;
  }

  public constructor() {
  }
}


export enum AzureRestorePointDataRestorePointTypeEnum {
  Compute = 'compute',
  RecoveryServices = 'recovery_services'
}

